import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import { useLoadProgress } from '../hooks/useLoadProgress'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: true,
    // login: false,
    title: '紙上的編號',
    placeholder: 'T000',
    alert: '編號有誤，請重新輸入，或請工作人員協助',
    useUserIdLogin: true,
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 暫存需加
  const [isReady, setIsReady] = useState(false)
  const userIdRef = useRef(null)
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const isWantsPregnant =
    '({q6} = 1) and ({q177} = 3 or {q177} = 4 or {q177} = 5) and ({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q173} = 0)'
  // 已停經
  const isPostmenopausal =
    '({q6} = 1) and ({q177} = 0) and ({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q173} = 0)'
  const isRecentDrinker = '({q246} = 1) and ({q248} = 0 or {q248} = 1)'

  const visibleIfConditionsInit = {
    q1: '{q0} = 1',
    q2: '({q0} = 1) and ({q1} = 0)',
    q3: '({q0} = 1) and ({q1} = 0)',
    q4: '({q0} = 1) and ({q1} = 1)',
    q5: '({q0} = 1) and ({q1} = 1) and ({q4} = 0)',

    q8: '{q7} = 7 or {q7} = 10 or {q7} = 13 or {q7} = 16 or {q7} = 20 or {q7} = 22 or {q7} = "other"',

    q10: '{q9} = 0',
    q11: '{q9} = 1',
    // A5
    q13: '{q12} = 0',
    q14: '({q12} = 0) and ({q13} anyof [0])',
    q15: '({q12} = 0) and ({q13} anyof [1])',
    q16: '({q12} = 0) and ({q13} anyof [2])',
    q17: '({q12} = 0) and ({q13} anyof [3])',
    q18: '({q12} = 0) and ({q13} anyof [4])',
    q19: '({q12} = 0) and ({q13} anyof [5])',
    q20: '({q12} = 0) and ({q13} anyof [6])',
    q21: '({q12} = 0) and ({q13} anyof [7])',
    q22: '({q12} = 0) and ({q13} anyof [8])',
    q23: '({q12} = 0) and ({q13} anyof [9])',
    q24: '({q12} = 0) and ({q13} anyof [10])',
    q25: '({q12} = 0) and ({q13} anyof [11])',
    q26: '({q12} = 0) and ({q13} anyof [12])',
    q27: '({q12} = 0) and ({q13} anyof [13])',
    // A6
    q29: '{q28} = 0 or {q28} = 3 or {q28} = 4 or {q28} = 5 or {q28} = "other"',
    q30: '{q28} = 1 or {q28} = 2 or {q29} = 1',
    q31: '({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q30} = 0)',
    q32: '({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q30} = 1 or {q30} = 2)',
    q33: '({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q30} = 0 or {q30} = 1 or {q30} = 2)',
    q34: '{q28} = 1 or {q28} = 2 or {q29} = 1',
    q35: '({q28} = 1 or {q28} = 2 or {q29} = 1) and ({q34} = 7 or {q34} = 10 or {q34} = 13 or {q34} = 16 or {q34} = 20 or {q34} = 22 or {q34} = "other")',
    // A7
    q37: '{q36} = 0',
    q38: '{q36} = 1 or {q36} = 2',
    q40: '{q39} = 0',
    q41: '{q39} = 1 or {q39} = 2',
    // B3
    q45: '{q44} = 1',
    q46: '({q44} = 1) and ({q45} = 1)',
    q47: '({q44} = 1) and ({q45} = 1) and ({q46} = 1)',
    q48: '{q44} = 1',
    // B4
    q50: '{q49} = 1',
    q51: '({q49} = 1) and ({q50} = 1)',
    q52: '({q49} = 1) and ({q50} = 1)',
    q53: '({q49} = 1) and ({q50} = 1) and ({q52} = 1)',
    q54: '{q49} = 1',
    q55: '{q49} = 1',
    q56: '{q49} = 1',
    q57: '({q49} = 1) and ({q56} = 1)',
    q58: '{q49} = 1',
    q59: '{q49} = 1',
    q60: '({q49} = 1) and ({q59} = 1)',
    q61: '{q49} = 1',
    q62: '({q49} = 1) and ({q61} = 1)',
    // B5
    q64: '{q63} = 1',
    q65: '({q63} = 1) and ({q64} = 1)',
    q66: '({q63} = 1) and ({q64} = 1) and ({q65} = 1)',
    q67: '{q63} = 1',
    // B6
    q68: '({q44} = 1) and ({q49} = 1) and ({q63} = 1)',
    // B7
    q70: '{q69} = 1',
    q71: '{q69} = 1',
    q72: '{q69} = 1',
    q73: '({q69} = 1) and ({q72} = "other")',
    q74: '({q69} = 1) and ({q72} = 0)',
    q75: '{q69} = 1',
    q76: '({q69} = 1) and ({q75} = 1)',
    // B8
    q78: '{q77} = 1',
    q79: '{q78} = 1',
    q80: '{q78} = 1',
    q81: '{q78} = 1',
    q82: '{q78} = 1',
    q83: '{q78} = 1',
    q84: '{q78} = 1',
    q85: '{q78} = 1',
    // B9
    q91: '{q90} = 1',
    // B10
    q93: '{q92} = 1',
    q94: '{q92} = 1',
    q95: '({q92} = 1) and ({q94} = 1)',
    q96: '({q92} = 1) and ({q94} = 1) and ({q95} = 0)',
    q97: '({q92} = 1) and ({q94} = 1) and ({q95} = 1)',
    q98: '({q92} = 1) and ({q94} = 1)',
    // B11
    q100: '{q99} = 1',
    q101: '{q99} = 1',
    q102: '({q99} = 1) and ({q101} = 1)',
    q103: '({q99} = 1) and ({q101} = 1) and ({q102} = 0)',
    q104: '({q99} = 1) and ({q101} = 1) and ({q102} = 1)',
    q105: '({q99} = 1) and ({q101} = 1)',
    q106: '({q99} = 1) and ({q101} = 1) and ({q102} = 1)',
    // B11
    q111: '{q110} = 1',
    q112: '{q110} = 1',
    q113: '({q110} = 1) and ({q112} = 1)',
    q114: '{q110} = 1',
    // B12 癌症
    q116: '{q115} anyof [5]',
    q117: '{q115} anyof [5]',
    // B12 心臟
    q118: '{q115} anyof [0]',
    q119: '{q115} anyof [0]',
    q120: '{q115} anyof [0]',
    // B12 痛風
    q121: '{q115} anyof [1]',
    q122: '{q115} anyof [1]',
    q123: '{q115} anyof [1]',
    // B12 胃潰瘍或十二指腸潰瘍
    q124: '{q115} anyof [2]',
    q125: '{q115} anyof [2]',
    q126: '{q115} anyof [2]',
    // B12 肝膽疾病
    q127: '{q115} anyof [3]',
    q128: '{q115} anyof [3]',
    q129: '{q115} anyof [3]',
    // B12 骨質疏鬆
    q130: '{q115} anyof [4]',
    q131: '{q115} anyof [4]',
    // B12 癌症
    q132: '{q115} anyof [5]',
    q133: '{q115} anyof [5]',
    q134: '{q115} anyof [5]',
    q135: '({q115} anyof [5]) and ({q117} != 20)',
    q136: '({q115} anyof [5]) and ({q117} != 20)',
    q137: '({q115} anyof [5]) and ({q117} != 20)',
    // B12 關節炎
    q138: '{q115} anyof [6]',
    q139: '{q115} anyof [6]',
    q140: '{q115} anyof [6]',
    // B12 憂鬱症
    q141: '{q115} anyof [7]',
    q142: '{q115} anyof [7]',
    q143: '{q115} anyof [7]',
    // B12 思覺失調症
    q144: '{q115} anyof [8]',
    q145: '{q115} anyof [8]',
    q146: '{q115} anyof [8]',
    // B12 其他精神疾病
    q147: '{q115} anyof [9]',
    q148: '{q115} anyof [9]',
    q149: '{q115} anyof [9]',
    // B12 非癌症之攝護腺問題【限問男性】
    q150: '({q115} anyof [10]) and ({q6} = 0)',
    q151: '({q115} anyof [10]) and ({q6} = 0)',
    q152: '({q115} anyof [10]) and ({q6} = 0)',
    // 子宮卵巢疾病(不包括子宮卵巢癌)【限問女性】
    q153: '({q115} anyof [11]) and ({q6} = 1)',
    q154: '({q115} anyof [11]) and ({q6} = 1)',
    q155: '({q115} anyof [11]) and ({q6} = 1)',
    // B13
    q159: '{q158} = 0',
    q160: '{q158} = 1 or {q158} = 2 or {q158} = 3',
    q161: '({q159} = 1 or {q159} = 2 or {q159} = 3) or ({q160} = 1 or {q160} = 2 or {q160} = 3)',
    q162: '{q161} = 1',
    // B14
    q164: '{q163} = 1 or {q163} = "other"',
    q165: '({q163} = 1 or {q163} = "other") and ({q164} anyof [0])',
    q166: '({q163} = 1 or {q163} = "other") and ({q164} anyof [1] or {q165} = 0)',
    // B15
    q170: '{q169} = 1',
    q171: '{q169} = 1',
    q172: '{q169} = 1',
    q174: '{q173} = 1',
    q175: '{q173} = 1',
    q176: '{q173} = 1',
    // B16
    // q177 需母體年齡
    q177: '{q6} = 1',
    // B17
    q178: isWantsPregnant,
    q179: isWantsPregnant + ' and ({q178} = 1 or {q178} = 2)',
    q180: isWantsPregnant + ' and ({q178} = 1 or {q178} = 2) and ({q179} = 1)',
    q181: isWantsPregnant + ' and ({q178} = 1 or {q178} = 2) and ({q179} = 0)',
    // B18
    // q182 q183 需母體年齡
    q182: isPostmenopausal,
    q183: isPostmenopausal,
    q184: isPostmenopausal + ' and ({q183} = 1)',
    q185: isPostmenopausal + ' and ({q183} = 1)',
    q186: isPostmenopausal + ' and ({q183} = 1) and ({q185} = 1)',
    q187: isPostmenopausal + ' and ({q183} = 1)',
    q188: isPostmenopausal + ' and ({q183} = 1) and ({q187} = 1)',
    q189: isPostmenopausal + ' and ({q183} = 0 or {q183} = 1 or {q183} = 3)',
    q190: isPostmenopausal + ' and ({q183} = 0 or {q183} = 1 or {q183} = 3)',
    q191: isPostmenopausal + ' and ({q183} = 0 or {q183} = 1 or {q183} = 3)',
    // B19
    q193: '{q192} = 0',
    q194: '{q192} = 1 or {q192} = 2 or {q192} = 3',
    // C1
    q200: '{q199} = 2',
    q207: '{q206} = 1',
    q209: '{q208} = 1',
    q211: '{q210} = 1',
    q213: '{q212} = 1',
    // C4
    // q215 需母體年齡
    q215: '{q214} = 1',
    q216: '{q214} = 1 and {q215} = 0',
    // C5
    q218: '{q217} = 1',
    q219: '{q217} = 0',
    // C6
    q221: '{q220} = 1',
    q222: '{q220} = 1',
    // C7
    q224: '{q223} = 1',
    // C8
    // 225 226 需母體年齡
    q225: '{q6} = 1',
    q226: '{q6} = 1 and {q225} = 1',
    q227: '{q6} = 1 and {q225} = 1 and {q226} = 1',
    q228: '({q6} = 1 and {q225} = 1) and ({q226} = 0) or (({q226} = 1) and ({q227} = 2 or {q227} = 3 or {q227} = 4))',
    q229: '({q6} = 1 and {q225} = 1) and ({q226} = 2 or {q226} = 3 or {q226} = 4) or (({q226} = 1) and ({q227} = 2 or {q227} = 3 or {q227} = 4))',
    q230: '({q6} = 1 and {q225} = 1) and (({q226} = 2 or {q226} = 3 or {q226} = 4) or (({q226} = 1) and ({q227} = 2 or {q227} = 3 or {q227} = 4))) and ({q229} = 1)',
    // C9
    // 231 232 需母體年齡
    q232: '{q6} = 1',
    q233: '{q6} = 1 and {q232} = 1',
    q234: '({q6} = 1) and ({q232} = 0 or {q233} = 3 or {q233} = 4)',
    q235: '{q6} = 1',
    q236: '({q6} = 1) and ({q235} = 1',
    // C10
    // 237 240 需母體年齡
    q238: '{q237} = 1',
    q239: '{q237} = 0',
    q241: '{q240} = 1',
    // C11
    // 242 需母體年齡
    q243: '{q242} = 1',
    q244: '{q242} = 1',
    q245: '{q242} = 1',
    // D1
    q247: '{q246} = 1',
    q248: '{q246} = 1',
    q249: '({q246} = 1) and ({q248} = 0 or {q248} = 1 or {q248} = 2 or {q248} = 3)',

    q250: isRecentDrinker,
    q251: isRecentDrinker + ' and ({q250} anyof [0])',
    q252: isRecentDrinker + ' and ({q250} anyof [0])',
    q253: isRecentDrinker + ' and ({q250} anyof [0])',
    q254: isRecentDrinker + ' and ({q250} anyof [1])',
    q255: isRecentDrinker + ' and ({q250} anyof [1])',
    q256: isRecentDrinker + ' and ({q250} anyof [1])',
    q257: isRecentDrinker + ' and ({q250} anyof [2])',
    q258: isRecentDrinker + ' and ({q250} anyof [2])',
    q259: isRecentDrinker + ' and ({q250} anyof [2])',
    q260: isRecentDrinker + ' and ({q250} anyof [3])',
    q261: isRecentDrinker + ' and ({q250} anyof [3])',
    q262: isRecentDrinker + ' and ({q250} anyof [3])',
    q263: isRecentDrinker + ' and ({q250} anyof [4])',
    q264: isRecentDrinker + ' and ({q250} anyof [4])',
    q265: isRecentDrinker + ' and ({q250} anyof [4])',
    q266: isRecentDrinker + ' and ({q250} anyof [5])',
    q267: isRecentDrinker + ' and ({q250} anyof [5])',
    q268: isRecentDrinker + ' and ({q250} anyof [5])',
    q269: isRecentDrinker + ' and ({q250} anyof [6])',
    q270: isRecentDrinker + ' and ({q250} anyof [6])',
    q271: isRecentDrinker + ' and ({q250} anyof [6])',
    q272: isRecentDrinker + ' and ({q250} anyof [7])',
    q273: isRecentDrinker + ' and ({q250} anyof [7])',
    q274: isRecentDrinker + ' and ({q250} anyof [7])',
    q275: isRecentDrinker + ' and ({q250} anyof [8])',
    q276: isRecentDrinker + ' and ({q250} anyof [8])',
    q277: isRecentDrinker + ' and ({q250} anyof [8])',

    q278: isRecentDrinker,
    q279: isRecentDrinker + ' and ({q278} = 0)',
    q280: isRecentDrinker + ' and ({q278} = 0)',
    q281: isRecentDrinker + ' and ({q278} = 0)',
    q282: isRecentDrinker + ' and ({q278} = 1)',
    q283: isRecentDrinker + ' and ({q278} = 1)',
    q284: isRecentDrinker + ' and ({q278} = 1)',
    q285: isRecentDrinker + ' and ({q278} = 2)',
    q286: isRecentDrinker + ' and ({q278} = 2)',
    q287: isRecentDrinker + ' and ({q278} = 2)',
    q288: isRecentDrinker + ' and ({q278} = 3)',
    q289: isRecentDrinker + ' and ({q278} = 3)',
    q290: isRecentDrinker + ' and ({q278} = 3)',
    q291: isRecentDrinker + ' and ({q278} = 4)',
    q292: isRecentDrinker + ' and ({q278} = 4)',
    q293: isRecentDrinker + ' and ({q278} = 4)',
    q294: isRecentDrinker + ' and ({q278} = 5)',
    q295: isRecentDrinker + ' and ({q278} = 5)',
    q296: isRecentDrinker + ' and ({q278} = 5)',
    q297: isRecentDrinker + ' and ({q278} = 6)',
    q298: isRecentDrinker + ' and ({q278} = 6)',
    q299: isRecentDrinker + ' and ({q278} = 6)',
    q300: isRecentDrinker + ' and ({q278} = 7)',
    q301: isRecentDrinker + ' and ({q278} = 7)',
    q302: isRecentDrinker + ' and ({q278} = 7)',
    q303: isRecentDrinker + ' and ({q278} = 8)',
    q304: isRecentDrinker + ' and ({q278} = 8)',
    q305: isRecentDrinker + ' and ({q278} = 8)',

    q306: isRecentDrinker,
    q307: '({q246} = 1) and ({q248} = 0 or {q248} = 1 or {q248} = 2 or {q248} = 3)',
    q308: '({q246} = 1) and ({q248} = 0 or {q248} = 1 or {q248} = 2 or {q248} = 3) and ({q307} = 1 or {q307} = 2)',
    q309: '({q246} = 1) and ({q248} = 0 or {q248} = 1 or {q248} = 2 or {q248} = 3)',
    q310: '({q246} = 1) and ({q248} = 0 or {q248} = 1 or {q248} = 2 or {q248} = 3) and ({q309} = 1)',
    q313: '({q312} = 1)',
    // D2
    q315: '{q314} = 1 or {q314} = 2',
    q316: '({q314} = 1 or {q314} = 2) and ({q315} = 1)',
    q317: '({q314} = 1 or {q314} = 2) and ({q315} = 0)',
    q318: '({q314} = 1 or {q314} = 2) and ({q315} = 1)',
    q319: '({q314} = 1 or {q314} = 2)',
    q320: '({q314} = 1 or {q314} = 2) and ({q319} = "other")',
    q321: '({q314} = 1 or {q314} = 2) and ({q319} = "other") and ({q320} = 1)',
    // D2e
    q323: '{q322} = 1 or {q322} = 2',
    q324: '({q322} = 1 or {q322} = 2) and ({q323} = 1 or {q323} = 2)',
    q326: '{q325} = 1 or {q325} = 2',
    q327: '({q325} = 1 or {q325} = 2) and ({q326} = 1 or {q326} = 2)',
    q329: '{q328} = 1 or {q328} = 2',
    q330: '({q328} = 1 or {q328} = 2) and ({q329} = 1 or {q329} = 2)',
    q332: '{q331} = 1 or {q331} = 2',
    q333: '({q331} = 1 or {q331} = 2) and ({q332} = 1 or {q332} = 2)',
    q335: '{q334} = 1 or {q334} = 2',
    q336: '({q334} = 1 or {q334} = 2) and ({q335} = 1 or {q335} = 2)',
    q338: '{q337} = 1 or {q337} = 2',
    q339: '({q337} = 1 or {q337} = 2) and ({q338} = 1 or {q338} = 2)',
    q341: '{q340} = "other"',
    q342: '{q340} = "other"',
    q343: '({q340} = "other") and ({q342} = 1 or {q342} = 2)',
    // D3
    q345: '{q344} = 1',
    q346: '{q344} = 1 and {q345} = 1',
    q347: '{q344} = 1',
    q348: '{q344} = 1',
    q349: '{q344} = 1',
    q350: '{q344} = 1',
    q351: '{q344} = 1',
    // D4
    q353: '{q352} = 2',
    q354: '({q352} = 2) and ({q353} = 0)',
    q355: '({q352} = 2) and ({q353} = 0)',
    q356: '({q352} = 2) and ({q353} = 0) and ({q355} = 1)',
    q357: '({q352} = 2) and ({q353} = 0)',
    q358: '({q352} = 2) and ({q353} = 0)',
    q359: '({q352} = 2) and ({q353} = 1)',
    q360: '({q352} = 2) and ({q353} = 1) and ({q359} = 1 or {q359} = 2 or {q359} = 3 or {q359} = 4)',
    q361: '({q352} = 2) and ({q353} = 1) and ({q359} = 1 or {q359} = 2 or {q359} = 3 or {q359} = 4) and ({q360} = 0)',
    q362: '({q352} = 2) and ({q353} = 1)',
    q363: '({q352} = 2) and ({q353} = 1)',
    q364: '({q352} = 2) and ({q353} = 1) and ({q363} = 1)',
    q365: '({q352} = 2) and ({q353} = 1)',
    q366: '({q352} = 2) and ({q353} = 1)',
    q367: '({q352} = 2) and ({q353} = 1) and ({q366} = 1)',
    q368: '({q352} = 2) and ({q353} = 1) and ({q366} = 1)',
    q369: '({q352} = 2) and ({q353} = 1) and ({q366} = 1)',
    q370: '({q352} = 2) and ({q353} = 1)',
    q371: '({q352} = 2) and ({q353} = 1)',
    // D5
    // 373 需母體年齡
    q373: '({q314} = 2) or ({q352} = 2) or ({q352} = 2 and {q10} = 1)',
    q374: '{q373} = 1',
    q375: '({q373} = 0) or ({q373} = 1 and ({q374} = 2 or {q374} = 3 or {q374} = 4))',
    // D6
    q377: '{q376} = 0',
    q379: '{q378} = 1',
    // D7
    q384: '{q383} = 0 or {q383} = 1',
    // D8
    q386: '{q385} = 1 or {q385} = 2 or {q385} = 3 or {q385} = 4 or {q385} = 5 or {q385} = 6 or {q385} = 7',
    q388: '{q387} = 1 or {q387} = 2 or {q387} = 3 or {q387} = 4 or {q387} = 5 or {q387} = 6 or {q387} = 7',
    // D10
    q391: '{q390} = 1',
    q392: '{q390} = 1',
    q394: '{q393} = 1',
    q395: '{q393} = 1',
    q397: '{q396} = 1',
    q398: '{q397} = 1 or {q397} = 2 or {q397} = 3 or {q397} = 4 or {q397} = 5 or {q397} = 6 or {q397} = 7',
    q399: '{q396} = 1',
    q400: '{q399} = 1 or {q399} = 2 or {q399} = 3 or {q399} = 4 or {q399} = 5 or {q399} = 6 or {q399} = 7',
    q402: '{q401} = 1',
    q403: '{q401} = 1',
    q405: '{q404} = 1',
    q406: '{q404} = 1',
    // D12
    q409: '{q408} = 1',
    q410: '{q408} = 1',
    q411: '({q408} = 1) and ({q410} = 0 or {q410} = 1 or {q410} = 2 or {q410} = 3 or {q410} = 5)',
    // G1
    q423: '{q422} = 0',
    q424: '{q422} = 1',
    q425: '{q422} = 2',
    q426: '{q422} = 2',
    q427: '{q422} = 2',
    q428: '{q422} = 2',
    q429: '{q422} = 2',
    q430: '({q422} = 2) and ({q429} = 0)',
    q431: '({q422} = 2) and ({q429} = 1 or {q429} = 3)',
    q432: '{q422} = 2',
    // G2
    q434: '{q433} = 0 or {q433} = 2 or {q433} = 3',
    q438: '{q437} = 1',
    // O2
    q447: '{q446} anyof [0,1]',
    q450: '{q449} = 1',
    // I0
    q452: '{q451} anyof [0,1, 2, 3]',
    q453: '({q451} anyof [0,1, 2, 3]) and ({q452} = 1)',
    q454: '({q451} anyof [0,1, 2, 3]) and ({q452} = 1)',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q0} = 1)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    // 暫存需加
    userIdRef,
    choiceIndexMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 暫存需加
  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  // 暫存需加
  useLoadProgress({
    surveyModel: surveyModel, // 若 myAgreeJson 為 null，agreeSurvey 亦為 null
    convertedSurvey: myAgreeJson,
    isReady,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
  })

  // 暫存需加
  // SurveyModel 初始化完成 → 標記可互動
  useEffect(() => {
    if (agreeSurvey) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [agreeSurvey])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `我們的訪問到這邊告一段落，非常謝謝您的協助！`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // if (survey.getValue('q0') === 1) {
    setCompletionMessage(endMessage)
    // } else {
    //   setCompletionMessage(
    //     `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
    //   )
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    // 暫存需加
    requiresLogin,
    userIdRef, // 傳入 ref 而不是直接傳 userId
    enableProgressSaving: requiresLogin.login, // 根據登入需求啟用
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
